import { ENV } from '@env';

export const isStaging = (): boolean => {
  return ENV === 'STAGE';
};

export default isStaging;
